import React, { FC, useMemo } from 'react';
import Form from './Form';
import MagicFormItem, { ItemScheme } from './MagicFormItem';
import SubmitButton from '../Button/SubmitButton';
import { getDefaultData } from '../../Modules/MagicForm/Services/magicForm-defaultsData.service';
import { getValidationScheme } from '../../Modules/MagicForm/Services/magicForm-validationScheme.service';
import RemoveButton from '../Button/RemoveButton';
import { useInputValidation } from '../../Modules/Base/Hooks/useInputValidation';
import { MagicField } from '../../Enums/MagicField.enum';
import useTranslation from '../../Hooks/useTranslation';

interface MagicFormProps {
	formScheme: Array<ItemScheme>;
	onSubmit: (values: any) => void;
	customDefaultValues?: object;
	defaultValues?: object | undefined | null;
	submitText?: string;
	disableSubmit?: boolean;
	readOnly?: boolean;
	children?: React.ReactChild | React.ReactChild[];
	registerForChanges?: boolean;
	removeButton?: {
		title?: string;
		onRemove: () => void;
	};
	showCharCounter?: boolean;
}

const MagicForm: FC<MagicFormProps> = props => {
	const {
		formScheme,
		onSubmit,
		defaultValues: customDefaultValues,
		submitText = 'base.shared.save',
		disableSubmit = false,
		readOnly = false,
		removeButton,
		registerForChanges = false,
		showCharCounter = true,
	} = props;

	const { getPriceInputValidation } = useInputValidation();
	const { t } = useTranslation();

	const defaultValues = useMemo(
		() => getDefaultData({ data: formScheme }),
		[formScheme],
	);
	const validationSchema = useMemo(
		() =>
			getValidationScheme(
				formScheme,
				{
					[MagicField.PRICE_WITH_CURRENCY]: getPriceInputValidation,
				},
				t,
			),
		[formScheme],
	);
	// const mergedDefaultValues = { ...customDefaultValues, ...defaultValues };
	const mergedDefaultValues = { ...customDefaultValues };
	const isInitialized =
		mergedDefaultValues && validationSchema && formScheme.length;

	if (!isInitialized) return <></>;

	const showSubmitButton = !readOnly;

	return (
		<Form
			defaultValues={mergedDefaultValues}
			schema={validationSchema}
			registerForChanges={registerForChanges}>
			{formScheme.map((item, index) => (
				<React.Fragment key={index}>
					<MagicFormItem
						itemScheme={item}
						disabled={readOnly}
						showCharCounter={showCharCounter}
					/>
				</React.Fragment>
			))}

			<div
				className='d-flex flex-row mt-4 align-items-center'
				style={{ gap: '24px' }}>
				{showSubmitButton && (
					<SubmitButton
						title={submitText}
						onSubmit={onSubmit}
						disabled={disableSubmit}
					/>
				)}
				{removeButton && (
					<RemoveButton
						onClick={removeButton?.onRemove}
						title={removeButton?.title}
					/>
				)}
			</div>
		</Form>
	);
};

export default MagicForm;
